let instance = null;

class BUS {
  constructor() {
    if (!instance) {
      instance = this;
    }
    return instance;
  }
  listen(name, func) {
    document.addEventListener(name, func);
  }
  stopListening(name, func) {
    document.removeEventListener(name, func);
  }
  trigger(name, data) {
    document.dispatchEvent(
      new CustomEvent(name, {
        detail: data
      })
    );
  }
}
export default BUS;



// WEBPACK FOOTER //
// ./src/utils/bus.js